import { render, staticRenderFns } from "./DistributionDialog.vue?vue&type=template&id=e2eb07fc&scoped=true&"
import script from "./DistributionDialog.vue?vue&type=script&lang=ts&"
export * from "./DistributionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DistributionDialog.vue?vue&type=style&index=0&id=e2eb07fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2eb07fc",
  null
  
)

export default component.exports